import Config from "../../../Utils/Config";
import { EComponentTypes } from "../../../Utils/Enums";
import { InstructorModel, UserModel } from "../../../Utils/Models";
import { formatDate } from "../../../Utils/Utils";
import { Vocabulary } from "../../../Utils/Vocabulary";

/**
 * Generates an array of column objects for the user salary report.
 */
export const userSalaryColumn = [
  {
    name: "incrementId",
    label: Vocabulary.id,
  },
  {
    name: "clientName",
    label: Vocabulary.cursant,
  },
  {
    name: "instructorName",
    label: Vocabulary.instructor,
    options: {
      customBodyRender: (value: string) => {
        return value ?? "-";
      },
      exportValue: (value: string) => value ?? "-",
    },
  },
  {
    name: "officeAssistantName",
    label: Config.roles.OFFICE_ASSISTANT,
    options: {
      customBodyRender: (value: string) => {
        return value ?? "-";
      },
      exportValue: (value: string) => value ?? "-",
    },
  },
  {
    name: "description",
    label: Vocabulary.description,
  },
  {
    name: "amount",
    label: Vocabulary.amount,
  },
  {
    name: "createdByUserName",
    label: Vocabulary.user,
  },
  {
    name: "createdAt",
    label: Vocabulary.createdAt,
    options: {
      customBodyRender: (value: Date) => {
        return formatDate(value);
      },
      exportValue: (value: Date) => value ? formatDate(value) : "",
    },
  },
];

/**
 * Generates an array of filter objects for the user salary report.
 *
 * @param {UserModel[]} officeAssitants - The list of users to use for the autocomplete filter.
 * @param {InstructorModel[]} instructors - The list of instructors to use for the autocomplete filter.
 *
 * @returns {Array<Filter>} An array of filter objects.
 */
export const userSalaryFilters = (
  officeAssitants: UserModel[],
  instructors: InstructorModel[]
) => [
  {
    property: "officeAssistantId",
    autocompleteFilterProperty: "_id",
    label: Config.roles.OFFICE_ASSISTANT,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: officeAssitants,
  },
  {
    property: "instructorId",
    autocompleteFilterProperty: "_id",
    label: Vocabulary.instructor,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: instructors,
  },
];
